import { type FC } from "react"

import type { DeviceLocation } from "types/geolocation.types"

import useAlertSettings from "helpers/hooks/useAlertSettings"
import { getDevicePosition, getMarkerIcon } from "helpers/utils/map"
import { getDeviceVersionAndTarget } from "helpers/utils/devices"
import { hasDeviceTriggeredAlerts } from "../../../helpers/utils/alerts"
import GeoPopup from "./GeoPopup"
import MapMarker from "./MapMarker"

interface IDeviceMapMarkersProps {
  devices: DeviceLocation[]
  // Off on a map that only shows where the devices are.
  showPopups?: boolean
}

const DeviceMapMarkers: FC<IDeviceMapMarkersProps> = ({ devices, showPopups = true }) => {
  const { orgAlertsBySettingId } = useAlertSettings()

  return (
    <>
      {devices?.map((deviceLocation: DeviceLocation) => {
        const { device, settingsStates } = deviceLocation
        const triggered =
          !!settingsStates &&
          hasDeviceTriggeredAlerts(settingsStates, orgAlertsBySettingId)
        const { version, target } = getDeviceVersionAndTarget(device)

        const icon = getMarkerIcon(triggered, version, target)
        const position = getDevicePosition(deviceLocation)

        return (
          position && (
            <MapMarker
              key={`device-marker-${device.id}`}
              position={position}
              icon={icon}
              zIndexOffset={triggered ? 500 : 100}
              popup={
                showPopups ? <GeoPopup type="device" data={deviceLocation} /> : undefined
              }
              tooltipContent={device.name}
              tooltipProps={{ permanent: true }}
              interactive={showPopups}
            />
          )
        )
      })}
    </>
  )
}

export default DeviceMapMarkers
